// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { requestRmaReturnInformationStyles } from "@guestsupply/App/Widgets/RequestRma/RequestRmaReturnInformation";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Edit from "@insite/mobius/Icons/Edit";
import { RadioStyle } from "@insite/mobius/Radio";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

requestRmaReturnInformationStyles.wrapper = {
    css: css`
        padding-bottom: 30px;
    `,
};
requestRmaReturnInformationStyles.header = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    `,
};
requestRmaReturnInformationStyles.sectionTitleText = {
    ...xOrderInformationStyles.address?.heading,
};
requestRmaReturnInformationStyles.titleText = {
    ...xOrderInformationStyles.labelWithDots,
};

requestRmaReturnInformationStyles.editInfoLink = {
    ...createLinkIconStyles(Edit, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 13,
                color: "primary",
                css: css`
                    margin-right: 4px;
                    opacity: 0.33;
                `,
            },
            position: "left",
        },

        css: css`
            display: flex;
            justify-content: center;
            margin-top: 15px;
        `,
    }),
};
requestRmaReturnInformationStyles.divider = {
    ...xOrderInformationStyles.address?.divider,
};

requestRmaReturnInformationStyles.returnInfoGridContainer = {
    css: css`
        padding-top: 12px;
    `,
};
requestRmaReturnInformationStyles.returnInfoGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding: 0 15px 4px;
    `,
};
requestRmaReturnInformationStyles.addressFormModal = { sizeVariant: "large" };
requestRmaReturnInformationStyles.returnInfoFormFieldGridItem = {
    width: [12, 12, 12, 6, 6],
};
requestRmaReturnInformationStyles.returnInfoActionsGridItem = {
    width: 12,
    css: css`
        gap: 10px;
        justify-content: flex-end;
    `,
};
requestRmaReturnInformationStyles.returnInfoModalCancelButton = {
    variant: "tertiary",
};
